/* eslint-disable no-loop-func */
// import dummyState from "App/common/dummies/backup_clients";
import initState from "./initState";

import * as types from "store/types";
import {
  updateObject,
  arrayToObject,
  deepClone,
  decompressionAlgorithm
} from "utils";
import { NOTIFICATIONS } from "consts";

const initProgress = {
  value: { progress: "0" },
  text: ""
};

function fetchClientsSuccess(state, action) {
  const updatedClients = { ...state.clients };
  const updatedClientsList = {};
  const machinesStatus = updatedClients.onlineClients;

  for (let val of action.clientsList) {
    if (val.clientUUID) {
      updatedClientsList[val.clientUUID] = val;

      // Status
      updatedClientsList[val.clientUUID].status = {
        value: updatedClientsList[val.clientUUID].status,
        progress: deepClone(initProgress),
        staticValue: updatedClientsList[val.clientUUID].status
      };
      updatedClientsList[val.clientUUID].init = {
        status: false,
        msg: ""
      };

      // Machines Status
      if (machinesStatus) {
        if (machinesStatus[val.clientUUID])
          updatedClientsList[val.clientUUID].machineStatus =
            machinesStatus[val.clientUUID].machineStatus;
        else updatedClientsList[val.clientUUID].machineStatus = "offline";
        updatedClients.loading = false;
      } else {
        updatedClientsList[val.clientUUID].machineStatus = "offline";
        updatedClients.loading = true;
      }

      // Priority for ordering
      if (!val.isConfigured) updatedClientsList[val.clientUUID].priority = 1;
      else if (updatedClientsList[val.clientUUID].machineStatus === "online")
        updatedClientsList[val.clientUUID].priority = 2;
      else if (updatedClientsList[val.clientUUID].machineStatus === "offline")
        updatedClientsList[val.clientUUID].priority = 3;
    }
  }
  updatedClients.list = updatedClientsList;

  return updateObject(state, {
    clients: updateObject(state.clients, updatedClients)
  });
}

function setRedirectFromRestoreToDashLoader(state, action) {
  return updateObject(state, {
    restoreRedirectLoader: action.loader
  });
}

function initiateBackup(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.clientUUID]: updateObject(
          state.clients.list[action.clientUUID],
          {
            init: {
              status: true,
              msg: NOTIFICATIONS.backup.initiateBackup,
              holdSliderOpen: action.holdSliderOpen
            },
            cancellingBackup: false
          }
        )
      })
    })
  });
}

function initiateFullBackup(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.clientUUID]: updateObject(
          state.clients.list[action.clientUUID],
          {
            init: {
              status: true,
              msg: NOTIFICATIONS.backup.initiateBackup
            },
            cancellingBackup: false
          }
        )
      })
    })
  });
}

function initiateRestore(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.data.clientUUID]: updateObject(
          state.clients.list[action.data.clientUUID],
          {
            init: {
              status: true,
              msg: NOTIFICATIONS.restore.initiateRestore
            },
            cancellingRestore: false
          }
        )
      })
    })
  });
}

function updateBackupProgress(state, action) {
  // if (!state.clients.list[action.client.clientUUID]) return state;
  // if (state.clients.list[action.client.clientUUID].cancellingBackup)
  //   return state;
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };

  const updatedStatus = {
    ...updatedClient.status
  };

  if (updatedClient.init.status && updatedClient.init.msg.includes("restore")) {
  } else {
    updatedClient.init = {
      status: action.client.snapshotInProgress > 0,
      msg:
        action.client.snapshotInProgress > 0
          ? NOTIFICATIONS.backup.snapShot[action.client.snapshotInProgress]
          : ""
    };
  }
  const updatedProgress = { ...updatedStatus.progress };
  let completing = true;

  // Check  this if there is issues in backup status
  for (let disk in action.client.diskInfo) {
    action.client.diskInfo[disk].forEach(vol => {
      if (vol.status === 1) updatedStatus.value = vol.status;
      if (vol.status !== 2) completing = false;
      if (vol.hasOwnProperty("progress")) updatedProgress.value = vol;
    });
  }
  updatedProgress.completing = completing;
  updatedProgress.completed = false;
  updatedProgress.failed = false;
  updatedProgress.diskInfo = { ...action.client.diskInfo };
  updatedProgress.pausedStatus = action.client.PauseStatus;

  updatedStatus.progress = updatedProgress;
  updatedClient.status = updatedStatus;

  //add to paused clients list if backup is paused, to maintain the status when groups are fetched and clients are updated in the state
  let pausedClients = { ...state.pausedClients };
  if (action.client.PauseStatus === 1) {
    pausedClients = {
      ...state.pausedClients,
      [action.client.clientUUID]: updatedStatus
    };
  } else {
    delete pausedClients[action.client.clientUUID];
  }

  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      })
    }),
    pausedClients
  });
}

function addNewBackupClient(state, action) {
  const updatedClient = { ...action.client };

  updatedClient.status = {
    value: updatedClient.status,
    progress: {
      value: { progress: 0 },
      text: ""
    },
    staticValue: updatedClient.status
  };
  updatedClient.init = {
    status: false,
    msg: ""
  };
  updatedClient.priority = 1;
  updatedClient.encryptionType = 0;
  updatedClient.groupId = 0;
  updatedClient.groupName = "NA";

  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      }),
      onlineClients: updateObject(state.clients.onlineClients, {
        [action.client.clientUUID]: {
          clientUUID: action.client.clientUUID,
          machineStatus: action.client.machineStatus
        }
      })
    })
  });
}

function configureBackupClient(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.clientUUID]: updateObject(
          state.clients.list[action.clientUUID],
          {
            isConfigured: true,
            priority:
              state.clients.list[action.clientUUID].machineStatus === "online"
                ? 2
                : 3
          }
        )
      })
    })
  });
}

function updateBackupMachineStatus(state, action) {
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };
  const updatedOnlineClients = { ...state.clients.onlineClients };
  updatedClient.machineStatus = action.client.machineStatus;
  updatedClient.priority = updatedClient.isConfigured
    ? action.client.machineStatus === "online"
      ? 2
      : 3
    : 1;
  updatedClient.nextBackupTime = action.client.nextBackupTime
    ? action.client.nextBackupTime
    : updatedClient.nextBackupTime;

  const updatedStatus = {
    ...updatedClient.status
  };
  const updatedInit = {
    ...updatedClient.init
  };

  if (action.client.machineStatus === "offline") {
    updatedInit.status = false;
    updatedStatus.value = updatedStatus.staticValue;

    //making progress.completing false when machine goes offline and backup progress is 100% due to service restart, or system shutdown.....
    if (updatedStatus.progress?.completing) {
      updatedStatus.progress.completing = false;
    }
    delete updatedClient.restoreStatus;
  }

  updatedClient.status = updatedStatus;
  updatedClient.init = updatedInit;

  if (updatedOnlineClients[action.client.clientUUID]) {
    updatedOnlineClients[action.client.clientUUID].machineStatus =
      action.client.machineStatus;
  } else {
    updatedOnlineClients[action.client.clientUUID] = action.client;
  }

  return state.clients.list[action.client.clientUUID]
    ? updateObject(state, {
        clients: updateObject(state.clients, {
          list:
            Object.keys(state.clients.list).length > 0
              ? updateObject(state.clients.list, {
                  [action.client.clientUUID]: updatedClient
                })
              : state.clients.list,
          onlineClients: updatedOnlineClients
        })
      })
    : state;
}

function updateBackupMachinesStatus(state, action) {
  const updatedClients = { ...state.clients };
  const updatedClientsList = updatedClients.list;
  const onlineClients = arrayToObject(action.clients, "clientUUID");

  if (
    updatedClientsList &&
    (Object.keys(updatedClientsList).length > 0 || updatedClients.failed)
  ) {
    for (let clientUUID in updatedClientsList) {
      const updatedClient = { ...updatedClientsList[clientUUID] };

      if (onlineClients[clientUUID])
        updatedClient.machineStatus = onlineClients[clientUUID].machineStatus;
      else updatedClient.machineStatus = "offline";

      if (updatedClient.isConfigured) {
        if (updatedClient.machineStatus === "online")
          updatedClient.priority = 2;
        else if (updatedClient.machineStatus === "offline")
          updatedClient.priority = 3;
      }

      updatedClientsList[clientUUID] = updatedClient;
    }
    updatedClients.loading = false;
  } else {
    //updatedClients.loading = action.clients.length !== 0 ? true : false;
    if (action.clients.length === 0 && !state.groups.loading) {
      updatedClients.loading = false;
    }
  }

  updatedClients.onlineClients = onlineClients;

  return updateObject(state, {
    clients: updateObject(state.clients, updatedClients)
  });
}

function initiateStopBackup(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.clientUUID]: updateObject(
          state.clients.list[action.clientUUID],
          {
            init: {
              status: true,
              msg: NOTIFICATIONS.backup.cancelBackup
            },
            cancellingBackup: true
          }
        )
      })
    })
  });
}

function stopBackup(state, action) {
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };
  const updatedStatus = { ...updatedClient.status };

  // TODO: add Status in PNS
  if (action.client.status === "BACKUPSTOPSUCCESS") updatedStatus.value = 4;
  else if (action.client.status === "BACKUPPAUSESUCCESS") {
    updatedStatus.value = 5;
    updatedClient.errorCode = 133;
  } else updatedStatus.value = 4;
  updatedStatus.showBackupTempStatus = true;
  updatedClient.init = {
    status: false,
    msg: ""
  };
  updatedStatus.progress = deepClone(initProgress);
  updatedClient.status = updatedStatus;
  updatedClient.nextBackupTime = action.client.nextBackupTime;
  updatedClient.cancellingBackup = false;

  let pausedClients = { ...state.pausedClients };
  delete pausedClients[action.client.clientUUID];

  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      })
    }),
    pausedClients
  });
}
//TODO: remove if not needed
function initiatePauseBackup(state, action) {
  return state;
}

function pauseBackup(state, action) {
  return state;
}

function initiateResumeBackup(state, action) {
  return state;
}

function resumeBackup(state, action) {
  return state;
}

function removeClientFromList(state, action) {
  const updatedList = { ...state.clients.list };
  const updatedOnlineClients = { ...state.clients.onlineClients };

  delete updatedList[action.clientUUID];
  delete updatedOnlineClients[action.clientUUID];

  let pausedClients = { ...state.pausedClients };
  delete pausedClients[action.clientUUID];

  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updatedList,
      onlineClients: updatedOnlineClients
    }),
    pausedClients
  });
}

function updateClientInfo(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updateObject(
          state.clients.list[action.client.clientUUID],
          {
            nextBackupTime: action.client.nextBackupTime
          }
        )
      })
    })
  });
}

function backupSetCompleted(state, action) {
  let updatedProgress = deepClone(initProgress);
  updatedProgress.completing = false;
  updatedProgress.failed = false;
  updatedProgress.completed = true;
  let updatedStatus = {
    value: action.client.status,
    progress: updatedProgress,
    showBackupTempStatus: true
  };
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updateObject(
          state.clients.list[action.client.clientUUID],
          {
            lastBackupTime: action.client.lastBackupTime,
            nextBackupTime: action.client.nextBackupTime,
            status: updateObject(
              state.clients.list[action.client.clientUUID].status,
              updatedStatus
            ),
            init: {
              status: false,
              msg: ""
            }
          }
        )
      })
    })
  });
}

function backupSetFailed(state, action) {
  let updatedProgress = deepClone(initProgress);
  updatedProgress.completing = false;
  updatedProgress.completed = false;
  updatedProgress.failed = true;
  let updatedStatus = {
    value: action.client.status,
    progress: updatedProgress,
    showBackupTempStatus: true
  };
  let pausedClients = { ...state.pausedClients };
  delete pausedClients[action.client.clientUUID];

  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updateObject(
          state.clients.list[action.client.clientUUID],
          {
            lastBackupTime:
              action.client.lastBackupTime != 0
                ? action.client.lastBackupTime
                : state.clients.list[action.client.clientUUID].lastBackupTime,
            nextBackupTime: action.client.nextBackupTime,
            status: updateObject(
              state.clients.list[action.client.clientUUID].status,
              updatedStatus
            ),
            init: {
              status: false,
              msg: ""
            },
            errorCode: action.client.errorCode
          }
        )
      })
    }),
    pausedClients
  });
}

function updateRestoreProgress(state, action) {
  if (!state.clients.list[action.client.clientUUID]) return state;
  if (state.clients.list[action.client.clientUUID].cancellingRestore)
    return state;
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };

  if (updatedClient.init.status && updatedClient.init.msg.includes("backup")) {
  } else {
    updatedClient.init = {
      status: false,
      msg: ""
    };
  }

  updatedClient.restoreStatus = action.client;
  if (action.client.status === 2) updatedClient.restoreStatus.completing = true;
  updatedClient.restoreStatus.completed = false;
  updatedClient.restoreStatus.failed = false;
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      })
    })
  });
}

function restoreSetCompletion(state, action) {
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };

  updatedClient.restoreStatus = {
    ...updatedClient.restoreStatus,
    ...action.client
  };
  updatedClient.restoreStatus.completing = false;
  updatedClient.restoreStatus.failed = false;
  updatedClient.restoreStatus.completed = true;
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      })
    })
  });
}

function restoreSetFailure(state, action) {
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };

  updatedClient.init = {
    status: false,
    msg: ""
  };
  updatedClient.restoreStatus = {
    ...updatedClient.restoreStatus,
    ...action.client
  };
  updatedClient.restoreStatus.completing = false;
  updatedClient.restoreStatus.completed = false;
  updatedClient.restoreStatus.failed = true;
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      })
    })
  });
}

function removeRestoreState(state, action) {
  const updatedClient = { ...state.clients.list[action.clientUUID] };

  delete updatedClient.restoreStatus;
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.clientUUID]: updatedClient
      })
    })
  });
}

function initiateStopRestore(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.clientUUID]: updateObject(
          state.clients.list[action.clientUUID],
          {
            init: {
              status: true,
              msg: NOTIFICATIONS.restore.cancelRestore
            },
            cancellingRestore: true
          }
        )
      })
    })
  });
}

function stopRestore(state, action) {
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };
  updatedClient.cancellingRestore = true;
  const updatedStatus = { ...updatedClient.status };
  updatedStatus.value = updatedStatus.staticValue;
  updatedClient.init = {
    status: false,
    msg: ""
  };
  action.client.status = 4;

  updatedClient.restoreStatus = {
    ...updatedClient.restoreStatus,
    ...action.client
  };
  delete updatedClient.cancellingRestore;
  delete updatedClient.restoreStatus.cancellingRestore;
  updatedClient.status = updatedStatus;
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      })
    })
  });
}

function initiateImageRestore(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.data.clientUUID]: updateObject(
          state.clients.list[action.data.clientUUID],
          {
            init: {
              status: true,
              msg: NOTIFICATIONS.imageRestore.initiateImageRestore
            }
          }
        )
      })
    })
  });
}

function updateImageRestoreProgress(state, action) {
  if (!state.clients.list[action.client.clientUUID]) return state;
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };

  if (!updatedClient.cancellingRestore) {
    updatedClient.init = {
      status: false,
      msg: ""
    };
  }

  const responseClient = { ...action.client };

  const updatedStatus = {
    ...updatedClient.status
  };

  const updatedProgress = { ...updatedStatus.progress };
  let completing = true;
  let showMsg = false;
  let driveName = "";
  for (let disk in responseClient.diskInfo) {
    responseClient.diskInfo[disk].forEach(vol => {
      if (vol.status === 1) responseClient.status = vol.status;
      if (vol.status !== 2) completing = false;
      if (vol.status === 6) {
        showMsg = true;
        driveName = vol.drive;
      }
      if (vol.hasOwnProperty("progress")) updatedProgress.value = vol;
    });
  }

  if (!updatedClient.cancellingRestore) {
    if (showMsg) {
      updatedClient.init = {
        status: true,
        msg: NOTIFICATIONS.restore.preparingImageRestore + driveName
      };
    } else {
      updatedClient.init = {
        status: false,
        msg: ""
      };
    }
  }

  for (let disk in responseClient.diskInfo) {
    for (let vol in responseClient.diskInfo[disk]) {
      if (responseClient.diskInfo[disk][vol].status === 0) {
        updatedProgress.value = { ...responseClient.diskInfo[disk][vol] };
      }
    }
  }

  updatedStatus.progress = updatedProgress;
  updatedClient.status = updatedStatus;
  updatedClient.restoreStatus = responseClient;
  updatedClient.restoreStatus.completing = completing;
  updatedClient.restoreStatus.failed = false;
  updatedClient.restoreStatus.completed = false;
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [responseClient.clientUUID]: updatedClient
      })
    })
  });
}

function removeBackupTempStatus(state, action) {
  const updatedClient = { ...state.clients.list[action.clientUUID] };
  const updatedStatus = { ...updatedClient.status };

  updatedStatus.showBackupTempStatus = false;
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.clientUUID]: updateObject(
          state.clients.list[action.clientUUID],
          {
            status: updateObject(
              (state.clients.list[action.clientUUID]?.status, updatedStatus)
            )
          }
        )
      })
    })
  });
}

function dashboardAPIDown(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      loading: false,
      failed: {
        msg: action.data.msg,
        status: action.data.status
      }
    })
  });
}

function hideDashboardNotify(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      notify: updateObject(state.clients.notify, {
        show: false
      })
    })
  });
}

function fetchClientStatusSuccess(state, action) {
  if (action.select === "status") {
    return updateObject(state, {
      clients: updateObject(state.clients, {
        list: updateObject(state.clients.list, {
          [action.data.clientUUID]: updateObject(
            state.clients.list[action.data.clientUUID],
            {
              status: updateObject(
                state.clients.list[action.data.clientUUID].status,
                { value: action.data.status }
              )
            }
          )
        })
      })
    });
  } else if (action.select === "cloudUsage")
    return updateObject(state, {
      clients: updateObject(state.clients, {
        list: updateObject(state.clients.list, {
          [action.data.clientUUID]: updateObject(
            state.clients.list[action.data.clientUUID],
            {
              cloudUsage: action.data.cloudUsage
            }
          )
        })
      })
    });
  else if (action.select === "errorCode") {
    const status = state.clients.list[action.data.clientUUID]?.status;
    return updateObject(state, {
      clients: updateObject(state.clients, {
        list: updateObject(state.clients.list, {
          [action.data.clientUUID]: updateObject(
            state.clients.list[action.data.clientUUID],
            {
              errorCode:
                // status?.value === 1 || status?.value === 5
                //   ? 209
                state.clients.list[action.data.clientUUID]?.errorCode
            }
          )
        })
      })
    });
  }
}
function PNSDown(state, action) {
  if (action.bool) {
    return updateObject(state, {
      clients: updateObject(state.clients, {
        loading: false,
        onlineClients: {}
      })
    });
  } else return state;
}

function fetchClientVersionInfoStart(state, action) {
  return updateObject(state, {
    versionInfo: {
      versionNo: "",
      releaseDate: ""
    }
  });
}

function fetchClientVersionInfoSuccess(state, action) {
  return updateObject(state, {
    versionInfo: updateObject(state.versionInfo, {
      versionNo: action.data.version_no,
      releaseDate: action.data.release_date
    })
  });
}

function downloadClientSetupStart(state) {
  return updateObject(state, {
    downaloadingClient: true
  });
}

function downloadClientSetupComplete(state) {
  return updateObject(state, {
    downaloadingClient: false
  });
}

function fetchDeploymentTokenSuccess(state, action) {
  return updateObject(state, {
    deploymentToken: action.token
  });
}

function downloadClientMSIStart(state) {
  return updateObject(state, {
    downloadingMSI: true
  });
}

function downloadClientMSIComplete(state) {
  return updateObject(state, {
    downloadingMSI: false
  });
}

function enableBackupPlanSuccess(state, action) {
  const updateClientsList = { ...state.clients.list };
  if (action.data.devices) {
    action.data.devices.forEach(element => {
      updateClientsList[element.clientUUID].backupPlanStatus = 1;
    });
  }
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, updateClientsList)
    })
  });
}

function disableBackupPlanSuccess(state, action) {
  const updateClientsList = { ...state.clients.list };
  if (action.data.devices) {
    action.data.devices.forEach(element => {
      updateClientsList[element.clientUUID].backupPlanStatus = 2;
    });
  }
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, updateClientsList)
    })
  });
}

function fetchGroupsStart(state) {
  return state;
}

function fetchGroupsSuccess(state, action) {
  //Adding to groups state
  const updatedGroups = { ...state.groups };
  updatedGroups.loading = false;
  const groupsResponse = decompressionAlgorithm(action.data);
  groupsResponse.forEach(group => {
    updatedGroups.list[group.groupId] = {
      ...group,
      clients: group.clients.reduce(
        (obj, item) => Object.assign(obj, { [item.clientUUID]: item }),
        {}
      )
    };
  });

  //Adding to clients state
  const updatedClients = { ...state.clients };
  const updatedClientsList = {};
  const machinesStatus = updatedClients.onlineClients;

  const clientsFromGroup = [];
  groupsResponse.forEach(group => {
    if (group.clients_count > 0) {
      group.clients.forEach(client => {
        clientsFromGroup.push({
          ...client,
          groupName: group.groupId === 0 ? "NA" : group.groupName,
          groupId: group.groupId
        });
      });
    }
  });

  for (let val of clientsFromGroup) {
    if (val.clientUUID) {
      updatedClientsList[val.clientUUID] = val;

      // Status
      if (state.pausedClients[val.clientUUID]?.progress?.pausedStatus === 1) {
        updatedClientsList[val.clientUUID].status =
          state.pausedClients[val.clientUUID];
      } else {
        updatedClientsList[val.clientUUID].status = {
          value: updatedClientsList[val.clientUUID].status,
          progress: deepClone(initProgress),
          staticValue: updatedClientsList[val.clientUUID].status
        };
      }
      updatedClientsList[val.clientUUID].init = {
        status: false,
        msg: ""
      };

      // Machines Status
      if (machinesStatus) {
        if (machinesStatus[val.clientUUID])
          updatedClientsList[val.clientUUID].machineStatus =
            machinesStatus[val.clientUUID].machineStatus;
        else updatedClientsList[val.clientUUID].machineStatus = "offline";
      } else {
        updatedClientsList[val.clientUUID].machineStatus = "offline";
      }

      // Priority for ordering
      if (!val.isConfigured) updatedClientsList[val.clientUUID].priority = 1;
      else if (updatedClientsList[val.clientUUID].machineStatus === "online")
        updatedClientsList[val.clientUUID].priority = 2;
      else if (updatedClientsList[val.clientUUID].machineStatus === "offline")
        updatedClientsList[val.clientUUID].priority = 3;
    }
  }
  updatedClients.loading = false;
  updatedClients.list = updatedClientsList;

  return updateObject(state, {
    groups: updatedGroups,
    clients: updateObject(state.clients, updatedClients)
  });
}

function fetchGroupsFailure(state) {
  return state;
}

function addClientsToGroupStart(state, action) {
  return state;
}

function addClientsToGroupSuccess(state, action) {
  const updatedGroups = { ...state.groups };
  const updatedClients = { ...state.clients };
  action.data.devices[0].clientUUIDs
    .replace(/'/g, "")
    .split(",")
    .forEach(clientUUID => {
      updatedGroups.list[action.data.groupID].clients[clientUUID] =
        updatedClients.list[clientUUID];
      updatedGroups.list[action.data.groupID].clients_count += 1;
      updatedClients.list[clientUUID] = {
        ...updatedClients.list[clientUUID],
        groupId: action.data.groupID,
        groupName: updatedGroups.list[action.data.groupID].groupName
      };
    });

  return updateObject(state, {
    groups: updatedGroups,
    clients: updatedClients
  });
}

function addClientsToGroupFailure(state, action) {
  return state;
}

function deleteDashboardGroupSuccess(state, action) {
  const updatedGroups = { ...state.groups };
  const updatedClients = { ...state.clients };

  if (updatedGroups.list[action.data.groupIDs[0]].clients_count > 0)
    Object.keys(updatedGroups.list[action.data.groupIDs[0]].clients).forEach(
      v => {
        if (v !== null && v)
          updatedClients.list[v] = {
            ...updatedClients.list[v],
            groupId: 0,
            groupName: "NA"
          };
      }
    );
  delete updatedGroups.list[action.data.groupIDs[0]];

  return updateObject(state, {
    groups: updatedGroups,
    clients: updatedClients
  });
}

function renameDashboardGroupNameSuccess(state, action) {
  const updatedGroups = { ...state.groups };
  const updatedClients = { ...state.clients };
  updatedGroups.list[action.data.groupID] = {
    ...updatedGroups.list[action.data.groupID],
    groupName: action.data.groupName
  };
  Object.keys(updatedGroups.list[action.data.groupID].clients).forEach(
    clientUUID => {
      updatedClients.list[clientUUID] &&
        (updatedClients.list[clientUUID] = {
          ...updatedClients.list[clientUUID],
          groupId: action.data.groupID,
          groupName: action.data.groupName
        });
    }
  );
  return updateObject(state, {
    groups: updatedGroups,
    clients: updatedClients
  });
}

function renameDashboardGroupNameFailure(state) {
  return state;
}

function createNewGroupDashboardSuccess(state, action) {
  const updatedGroups = { ...state.groups };
  updatedGroups.list = {
    ...updatedGroups.list,
    [action.data.groupID]: {
      groupId: action.data.groupID,
      groupName: action.data.groupName,
      clients_count: 0,
      clients: {}
    }
  };
  return updateObject(state, {
    groups: updatedGroups
  });
}

function createNewGroupDashboardFailure(state) {
  return state;
}

function removeClientsFromGroupSuccess(state, action) {
  const updatedGroups = { ...state.groups };
  const updateClients = { ...state.clients };

  let selectedClients = action.data.devices[0].clientUUIDs.split(",");
  selectedClients.forEach(v => {
    if (v.replaceAll("'", "") !== "null") {
      delete updatedGroups.list[action.data.groupID].clients[
        v.replaceAll("'", "")
      ];
      updateClients.list[v.replaceAll("'", "")] = {
        ...updateClients.list[v.replaceAll("'", "")],
        groupId: 0,
        groupName: "NA"
      };
    }
  });

  updatedGroups.list[action.data.groupID].clients_count =
    updatedGroups.list[action.data.groupID].clients_count -
    selectedClients.length;
  if (updatedGroups.list[action.data.groupID].clients_count < 0)
    updatedGroups.list[action.data.groupID].clients_count = 0;

  return updateObject(state, {
    groups: updatedGroups,
    clients: updateClients
  });
}

function fetchClientServerIPAddressResponse(state, action) {
  const updatedClient = { ...state.clients.list[action.client.clientUUID] };

  updatedClient.serverIPAddress = action?.ipAddress?.server_ip_address
    ? action.ipAddress.server_ip_address
    : "";

  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.client.clientUUID]: updatedClient
      })
    })
  });
}

function initiateVirtualizationStart(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.data.client_uuid]: updateObject(
          state.clients.list[action.data.client_uuid],
          {
            init: {
              status: true,
              msg: action.msg
            }
          }
        )
      })
    })
  });
}

function initiateVirtualizationSuccess(state, action) {
  const tempClient = { ...state.clients.list[action.data.client_uuid] };
  tempClient.init = { msg: "", status: false };
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.data.client_uuid]: tempClient
      })
    })
  });
}

function controlVMFromDashboardStart(state, action) {
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.data.client_uuid]: updateObject(
          state.clients.list[action.data.client_uuid],
          {
            init: {
              status: true,
              msg: action.msg
            }
          }
        )
      })
    })
  });
}

function controlVMFromDashboardSuccess(state, action) {
  const tempClient = { ...state.clients.list[action.data.client_uuid] };
  tempClient.init = { msg: "", status: false };
  return updateObject(state, {
    clients: updateObject(state.clients, {
      list: updateObject(state.clients.list, {
        [action.data.client_uuid]: tempClient
      })
    })
  });
}

function controlVMFromDashboardFailure(state, action) {
  return state;
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_CLIENTS_SUCCESS:
      return fetchClientsSuccess(state, action);
    case types.INITIATE_BACKUP:
      return initiateBackup(state, action);
    case types.INITIATE_FULL_BACKUP:
      return initiateFullBackup(state, action);
    case types.UPDATE_BACKUP_PROGRESS:
      if (
        state.clients.list &&
        state.clients.list[action.client.clientUUID] &&
        !state.clients.list[action.client.clientUUID].cancellingBackup
      )
        return updateBackupProgress(state, action);
      return state;
    case types.BACKUP_SET_COMPLETED:
      return backupSetCompleted(state, action);
    case types.BACKUP_SET_FAILED:
      return backupSetFailed(state, action);
    case types.ADD_NEW_BACKUP_CLIENT:
      return addNewBackupClient(state, action);
    case types.CONFIGURE_BACKUP_CLIENT:
      return configureBackupClient(state, action);
    case types.UPDATE_BACKUP_MACHINE_STATUS:
      return updateBackupMachineStatus(state, action);
    case types.UPDATE_BACKUP_MACHINES_STATUS:
      return updateBackupMachinesStatus(state, action);
    case types.INITIATE_STOP_BACKUP:
      return initiateStopBackup(state, action);
    case types.STOP_BACKUP:
      return stopBackup(state, action);
    case types.INITIATE_PAUSE_BACKUP:
      return initiatePauseBackup(state, action);
    case types.PAUSE_BACKUP:
      return pauseBackup(state, action);
    case types.INITIATE_RESUME_BACKUP:
      return initiateResumeBackup(state, action);
    case types.RESUME_BACKUP:
      return resumeBackup(state, action);
    case types.UPDATE_CLIENT_INFO:
      return updateClientInfo(state, action);
    case types.REMOVE_CLIENT_FROM_LIST:
      return removeClientFromList(state, action);
    case types.UPDATE_RESTORE_PROGRESS:
      return updateRestoreProgress(state, action);
    case types.INITIATE_RESTORE:
      return initiateRestore(state, action);
    case types.RESTORE_SET_COMPLETION:
      return restoreSetCompletion(state, action);
    case types.RESTORE_SET_FAILURE:
      return restoreSetFailure(state, action);
    case types.REMOVE_RESTORE_STATE:
      return removeRestoreState(state, action);
    case types.INITIATE_STOP_RESTORE:
      return initiateStopRestore(state, action);
    case types.STOP_RESTORE:
      return stopRestore(state, action);
    case types.INITIATE_IMAGE_RESTORE:
      return initiateImageRestore(state, action);
    case types.UPDATE_IMAGE_RESTORE_PROGRESS:
      return updateImageRestoreProgress(state, action);
    case types.REMOVE_BACKUP_TEMP_STATUS:
      return removeBackupTempStatus(state, action);
    case types.DASHBOARD_API_DOWN:
      return dashboardAPIDown(state, action);
    case types.HIDE_DASHBOARD_NOTIFY:
      return hideDashboardNotify(state, action);
    case types.FETCH_CLIENT_STATUS_SUCCESS:
      return fetchClientStatusSuccess(state, action);
    case types.PNS_DOWN:
      return PNSDown(state, action);
    case types.FETCH_CLIENT_VERSION_INFO_START:
      return fetchClientVersionInfoStart(state, action);
    case types.FETCH_CLIENT_VERSION_INFO_SUCCESS:
      return fetchClientVersionInfoSuccess(state, action);
    case types.DOWNLOAD_CLIENT_SETUP_START:
      return downloadClientSetupStart(state);
    case types.DOWNLOAD_CLIENT_SETUP_COMPLETE:
      return downloadClientSetupComplete(state);
    case types.FETCH_DEPLOYMENT_TOKEN_SUCCESS:
      return fetchDeploymentTokenSuccess(state, action);
    case types.DOWNLOAD_CLIENT_MSI_START:
      return downloadClientMSIStart(state, action);
    case types.DOWNLOAD_CLIENT_MSI_COMPLETE:
      return downloadClientMSIComplete(state);
    case types.ENABLE_BACKUP_PLAN_SUCCESS:
      return enableBackupPlanSuccess(state, action);
    case types.DISABLE_BACKUP_PLAN_SUCCESS:
      return disableBackupPlanSuccess(state, action);
    case types.FETCH_GROUPS_START:
      return fetchGroupsStart(state);
    case types.FETCH_GROUPS_SUCCESS:
      return fetchGroupsSuccess(state, action);
    case types.FETCH_GROUPS_FAILURE:
      return fetchGroupsFailure(state);
    case types.ADD_CLIENTS_TO_GROUP_START:
      return addClientsToGroupStart(state, action);
    case types.ADD_CLIENTS_TO_GROUP_SUCCESS:
      return addClientsToGroupSuccess(state, action);
    case types.ADD_CLIENTS_TO_GROUP_FAILURE:
      return addClientsToGroupFailure(state, action);
    case types.DELETE_DASHBOARD_GROUP_SUCCESS:
      return deleteDashboardGroupSuccess(state, action);
    case types.RENAME_DASHBOARD_GROUP_NAME_SUCCESS:
      return renameDashboardGroupNameSuccess(state, action);
    case types.RENAME_DASHBOARD_GROUP_NAME_FAILURE:
      return renameDashboardGroupNameFailure(state);
    case types.CREATE_NEW_GROUP_DASHBOARD_SUCCESS:
      return createNewGroupDashboardSuccess(state, action);
    case types.CREATE_NEW_GROUP_DASHBOARD_FAILURE:
      return createNewGroupDashboardFailure(state);
    case types.REMOVE_CLIENTS_FROM_GROUP_SUCCESS:
      return removeClientsFromGroupSuccess(state, action);
    case types.FETCH_CLIENT_SERVERIPADDRESS_RESPONSE:
      return fetchClientServerIPAddressResponse(state, action);
    case types.SET_REDIRECT_RESTORE_TO_DASHBOARD_LOADER:
      return setRedirectFromRestoreToDashLoader(state, action);
    case types.INITIATE_VIRTUALIZATION_START:
      return initiateVirtualizationStart(state, action);
    case types.INITIATE_VIRTUALIZATION_SUCCESS:
      return initiateVirtualizationSuccess(state, action);
    case types.CONTROL_VM_FROM_DASHBOARD_START:
      return controlVMFromDashboardStart(state, action);
    case types.CONTROL_VM_FROM_DASHBOARD_SUCCESS:
      return controlVMFromDashboardSuccess(state, action);
    case types.CONTROL_VM_FROM_DASHBOARD_FAILURE:
      return controlVMFromDashboardFailure(state, action);
    default:
      return state;
  }
}

export default reducer;
